module.exports = __webpack_public_path__ + "static/img/fullscreen-image_time-attendance.fba8d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_time-attendance.png
// module id = FLmH
// module chunks = 0